import PARENT_E2E_PREFIX from '../e2ePrefix';

const E2E_PREFIX = `${PARENT_E2E_PREFIX}-personal-carrier-value`;

export default E2E_PREFIX;
